// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../feedback-indicators/Badge.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Spaces from "../theme/Spaces.res.js";
import * as Spinner from "../feedback-indicators/Spinner.res.js";
import * as InlineText from "../layout-and-structure/InlineText.res.js";
import * as TooltipIcon from "../overlays/TooltipIcon.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let style = {
  lineHeight: "12px"
};

let infinityStyle = {
  fontSize: "1.4em"
};

function Metric$BadgeProgressionText(props) {
  let value = props.value;
  return JsxRuntime.jsx("span", {
    children: isFinite(value) ? (
        value > 0 ? JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: "+ " + I18n.percentFormat(undefined, undefined, 0, value)
          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: I18n.percentFormat(undefined, undefined, 0, value).replace("-", "- ")
          })
      ) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          value > 0 ? "+ " : "- ",
          JsxRuntime.jsx("span", {
            children: "∞",
            style: infinityStyle
          })
        ]
      }),
    "aria-label": "percentageGrowth",
    style: style
  });
}

function getVariation(value) {
  let roundedValue = Math.round(value * 100);
  if (roundedValue >= 1) {
    return "success";
  } else if (roundedValue <= -1) {
    return "danger";
  } else {
    return "neutral";
  }
}

function style$1(muted) {
  return {
    backgroundColor: "#fefefe",
    display: "flex",
    height: "100%",
    minWidth: "180px",
    padding: String(Spaces.medium) + `px ` + String(Spaces.large) + `px`,
    position: "relative",
    borderRadius: "5px",
    boxShadow: muted ? `rgba(37, 36, 58, 0.01) 0 6px 10px` : `rgba(37, 36, 58, 0.08) 0 0 10px,
             rgba(37, 36, 58, 0.01) 4px 0 4px,
             rgba(37, 36, 58, 0.01) -4px 0 4px`,
    flex: "1",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: "border-box",
    transition: "box-shadow .3s ease-in-out"
  };
}

let titleBoxStyle = {
  marginRight: "12px",
  paddingBottom: "8px"
};

let titleBoxBadgeStyle = {
  display: "inline-flex",
  position: "relative",
  top: "-2px"
};

let titleBoxTooltipStyle = {
  marginLeft: "3px",
  transform: "scale(0.95)"
};

let spinnerStyle = {
  position: "absolute",
  right: "8px",
  top: "8px"
};

function Metric(props) {
  let tooltip = props.tooltip;
  let percentageGrowth = props.percentageGrowth;
  let __loading = props.loading;
  let loading = __loading !== undefined ? __loading : false;
  let ref = React.useRef(null);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(Title.make, {
              children: props.title + "   ",
              level: 4,
              weight: "bold"
            }),
            percentageGrowth !== undefined && !Number.isNaN(percentageGrowth) ? JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx(Badge.make, {
                    children: JsxRuntime.jsx(Metric$BadgeProgressionText, {
                      value: percentageGrowth
                    }),
                    size: "small",
                    variation: getVariation(percentageGrowth)
                  }),
                  tooltip !== undefined ? JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(TooltipIcon.make, {
                        children: tooltip,
                        variation: "info",
                        altTriggerRef: ref
                      }),
                      style: titleBoxTooltipStyle
                    }) : null
                ],
                style: titleBoxBadgeStyle
              }) : null,
            loading ? JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Spinner.make, {
                  size: 16
                }),
                style: spinnerStyle
              }) : null
          ],
          linespace: "xxsmall"
        }),
        ref: Primitive_option.some(ref),
        style: titleBoxStyle
      }),
      props.children
    ],
    style: style$1(loading)
  });
}

let make = React.memo(Metric);

export {
  getVariation,
  make,
}
/* make Not a pure module */
